import {
    MINERAL_SAMPLE_LOADING,
    MINERAL_SAMPLE_SUCCESS,
    GET_MINERAL_ANALYSIS_PRICES,
    MINERAL_REPORT_LOADING,
    MINERAL_REPORT_SUCCESS,
    CREATE_MINERAL_REPORT,
    GET_MINERAL_REPORTS,
    GET_SINGLE_MINERAL_REPORT,
    UPDATE_MINERAL_REPORT,
    DELETE_MINERAL_REPORT,
    GET_MINERAL_SAMPLES
} from '../actions/mineralActions';

const initialState = {
    mineralSampleLoading: false,
    mineralSampleSuccess: false,
    mineralAnalysisPrices: [],
    mineralReportLoading: false,
    mineralReportSuccess: false,
    mineralReports: [],
    singleMineralReport: null,
    reportTotal: 0,
    reportPage: 1,
    mineralSamples: [],
    mineralSamplesTotal: 0
};

export default (state = initialState, action) => {
    switch (action.type) {
        case MINERAL_SAMPLE_LOADING:
            return {
                ...state,
                mineralSampleLoading: action.payload
            };
        case MINERAL_SAMPLE_SUCCESS:
            return {
                ...state,
                mineralSampleSuccess: action.payload
            };
        case GET_MINERAL_ANALYSIS_PRICES:
            return {
                ...state,
                mineralAnalysisPrices: action.payload || []
            };
        case MINERAL_REPORT_LOADING:
            return {
                ...state,
                mineralReportLoading: action.payload
            };
        case MINERAL_REPORT_SUCCESS:
            return {
                ...state,
                mineralReportSuccess: action.payload
            };
        case CREATE_MINERAL_REPORT:
            return {
                ...state,
                mineralReportLoading: false,
                mineralReportSuccess: true,
                singleMineralReport: action.payload
            };
        case GET_MINERAL_REPORTS:
            return {
                ...state,
                mineralReportLoading: false,
                mineralReports: action.payload.results || [],
                reportTotal: action.payload.total || 0,
                reportPage: action.payload.page || 1
            };
        case GET_SINGLE_MINERAL_REPORT:
            return {
                ...state,
                mineralReportLoading: false,
                singleMineralReport: action.payload
            };
        case UPDATE_MINERAL_REPORT:
            return {
                ...state,
                mineralReportLoading: false,
                singleMineralReport: action.payload
            };
        case DELETE_MINERAL_REPORT:
            return {
                ...state,
                mineralReportLoading: false,
                mineralReports: state.mineralReports.filter(r => r.reportNo !== action.payload)
            };
        case GET_MINERAL_SAMPLES:
            return {
                ...state,
                mineralSamples: action.payload.results || [],
                mineralSamplesTotal: action.payload.total || 0
            };
        default:
            return state;
    }
};